import { User } from '@mss/mss-component-library';

const emptyUser: User = {
  id: '',
  password: '',
  last_login: null,
  is_superuser: false,
  username: '',
  first_name: '',
  last_name: '',
  email: '',
  is_staff: false,
  is_active: true,
  date_joined: '',
  terms_agreed: null,
  groups: [],
  user_permissions: [],
};

export default emptyUser;
